<template>
  <div style="width: 1400px; height: 700px">
    <div class="info">
      Pano index:{{ index }}
      <button @click="change">Toggle</button>
    </div>
    <Pano @on-load="onLoad" :source="urls[index]"> </Pano>
  </div>
</template>

<script>
import { Pano } from "vuejs-vr";

export default {
  components: {
    Pano,
  },
  data() {
    return {
      urls: ["static/models/360_0117.JPG", "static/models/SAM_0119.JPG"],
      index: 0,
    };
  },
  methods: {
    onLoad() {
      this.loading = false;
    },
    change() {
      this.index = 1 - this.index;
    },
  },
};
</script>

<style lang="scss">
.info {
  position: absolute;
  top: 30px;
  left: 10%;

  button {
    padding: 10px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/test/TestVR.vue